module.exports = __webpack_public_path__ + "static/media/paymentsActive.90cd5f6c.svg";